import styles from './DeleteSmtpPanel.module.css';

import React, { useState, useEffect, useContext, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import io from 'io.js';

import { Icon, Panel, Button, Input, Label, Select, Hr, IconUpgrade, Avatar, Slider, FormRow } from 'ui-components';

const DeleteSmtpPanel = ({ show, onClose, smtp }) => {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const cancel = () => {
    onClose();
    setLoading(false);
    setSuccess(false);
  };

  const confirm = () => {
    if (loading) return;

    setLoading(true);

    io.socket.once('deleteSmtp', () => {
      setLoading(false);
      setSuccess(true);

      setTimeout(() => cancel(), 1000);
    });

    io.socket.emit('deleteSmtp', { _id: smtp._id });
  };

  return <Panel mainStyle={{
    height: '90vh'
  }} coverStyle={{
    width: '80vw',
    height: '90vh',
    maxWidth: '950px',
    minWidth: '850px', left: '-200px'
  }}className={styles.main} title="Confirm SMTP delete" show={show} loading={loading} success={success} buttons={[
    <Button theme="white" onClick={() => !loading && cancel()}>Cancel</Button>,
    <Button theme="black" onClick={() => confirm()}>Delete SMTP</Button>
  ]} onOutsideClick={() => !loading && cancel()}>
    <div className={styles.content}>
      {smtp && <p>Are you sure you want to delete <strong>{smtp.hostname}</strong>?</p>}
    </div>
  </Panel>;
};

export default DeleteSmtpPanel;
